module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-1.c1ea103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology-1-SD-WAN-img-1.png
// module id = tzAJ
// module chunks = 0